import type { ContactInfo, NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

const showroomAddress = 'تهران، خیابان ولیعصر، بالاتر از میدان ونک، پلاک ۲۱۵۰'

export const siteConfig: SiteConfig = {
    name: 'مبلمان نارون',
    shortName: 'نارون',
    tagline: 'مبلمان دست‌ساز',
    description: 'مبلمان دست‌ساز نارون؛ کاناپه، مبل راحتی، ناهارخوری و سرویس خواب با چوب خشک‌شده و پارچه‌های مقاوم، ساخت کارگاه خودمان با امکان سفارش در ابعاد و رنگ دلخواه.',
    url: getOrigin(),
    shareImage: 'https://mobleman-naroon.cdn.modulify.website/images/share/naroon-living-room.jpg'
}

export const contactInfo: ContactInfo = {
    phone: '۰۲۱-۸۸۶۶۴۴۲۲',
    phoneHref: 'tel:+982188664422',
    address: showroomAddress,
    hours: 'شنبه تا پنجشنبه، ساعت ۱۰ تا ۲۰',
    closedDays: 'جمعه‌ها و تعطیلات رسمی تعطیل است',
    mapUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(showroomAddress)}`
}

export const mainNav: NavLink[] = [
    { href: '/', label: 'خانه' },
    { href: '/products', label: 'محصولات' },
    { href: '/about', label: 'درباره نارون' },
    { href: '/contact', label: 'تماس با ما' }
]
